<template>
  <transition name="scale-in-out">
    <div class="splash-screen">
      <img class="logo" src="../assets/images/ccp-logo.svg" alt="The Capital of Card Payments logo" />
      <div class="content">
        <p>From Brighton to Edinburgh and everywhere in between, we helped 70,000 merchants process over 300m transactions last year. We gathered all that data and asked the ultimate question: what is the UK’s Capital of Card payments?<br>Explore our interactive map to find out.</p>
        <button @click="setActiveApp(true)">View Results</button>
      </div>
    </div>
  </transition>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'

  export default {
    name: 'splash-screen',
    computed: {
      ...mapGetters(['appIsActive'])
    },
    methods: {
      ...mapMutations(['setActiveApp'])
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  p {
    font-family:$ff-open-sans;
    font-size: 14px;
    line-height: 1.8;
    color: $brand-secondary;
  }

  .splash-screen {
    background: linear-gradient(-135deg, #E6F5FB 0%, #F8FDFF 100%);
    min-height: calc(100vh - 50px);
    text-align: center;
  }

  .logo {
    margin: 15px auto;
    width: 235px;
  }

  .content {
    margin: 0 auto;
    padding: 10px 25px;
  }

  button {
    background: $brand-primary;
    padding: 15px 0;
    border-radius: 2px;
    border: none;
    color: #fff;
    font-family: $ff-effra-regular;
    font-size: 17px;
    cursor: pointer;
    width: 100%;
    margin-top: 15px;
  }

  @media #{$breakpoint-md} {
    .scale-in-out-leave-active {
      transition: all $animation-timing-fn;
    }

    .scale-in-out-leave-to {
      transform: translateX(-50%);
      opacity: 0;
    }

    button {
      font-size: 17px;
      width: 70%;
    }

    .content {
      width: 75%;
      margin: 0 auto;
      padding: 10px 40px;
    }

    .splash-screen {
      background: #fff;
      display: block;
      margin: 0 auto;
      text-align: center;
      border-radius: 50%;
      width: 630px;
      height: 630px;
      min-height: inherit;
      overflow: hidden;
      // Since we are re centering the map for the splash screen, the circle is difficult to see thus and this shadow
      box-shadow: 0 0 200px rgba($brand-secondary, 0.08);
    }

    .logo {
      width: 101%;
      margin: 0 0 0 50%;
      transform: translate(-50%);
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/SplashScreen.vue